import React, { useEffect } from "react";

import { useGetDashboard } from "api/api-hooks/dashboards-hooks";
import usePrimeLocale from "hooks/usePrimeLocale";
import { ProgressSpinner } from "primereact/progressspinner";
import { Outlet, useParams } from "react-router-dom";
import useDashboardStore from "store/dashboard-store";
import DashboardMain from "./DashboardMain";

const DashboardRoute = () => {
  usePrimeLocale();
  const { dashboardId } = useParams();
  const { data, isLoading } = useGetDashboard(dashboardId as unknown as number);
  const { dashboard, setDashboard } = useDashboardStore(state => ({
    dashboard: state.dashboard,
    setDashboard: state.setDashboard,
  }));
  const setFromHistory = useDashboardStore(state => state.setFromHistory);

  useEffect(() => {
    if (data && dashboard?.id !== data.id) {
      setDashboard(data);
      setFromHistory(false);
    }
  }, [data, setDashboard, dashboard, setFromHistory]);

  if (isLoading) {
    return <ProgressSpinner />;
  }

  return (
    <>
      <DashboardMain />
      <Outlet />
    </>
  );
};

export default DashboardRoute;
